export enum EventType {
    XMAS_2021 = 'xmas_2021',
}